import { HighlightedCode } from '@/components/code/HighlightedCode';
import { highlightHql } from '@rock/hql';
import { type FC, useMemo } from 'react';

/** An applies-to query as read-only code, colored by what each word is. */
export const HqlCode: FC<{ query: string; block?: boolean }> = ({ query, block }) => {
    const stretches = useMemo(() => highlightHql(query), [query]);
    return <HighlightedCode stretches={stretches} block={block} />;
};
